import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

const LocationPin = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="22"
        height="28"
        viewBox="0 0 22 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.0002 14C11.7335 14 12.3613 13.7388 12.8835 13.2166C13.4057 12.6944 13.6668 12.0666 13.6668 11.3333C13.6668 10.6 13.4057 9.97218 12.8835 9.44996C12.3613 8.92774 11.7335 8.66663 11.0002 8.66663C10.2668 8.66663 9.63905 8.92774 9.11683 9.44996C8.59461 9.97218 8.3335 10.6 8.3335 11.3333C8.3335 12.0666 8.59461 12.6944 9.11683 13.2166C9.63905 13.7388 10.2668 14 11.0002 14ZM11.0002 23.8C13.7113 21.3111 15.7224 19.05 17.0335 17.0166C18.3446 14.9833 19.0002 13.1777 19.0002 11.6C19.0002 9.17774 18.2279 7.1944 16.6835 5.64996C15.1391 4.10551 13.2446 3.33329 11.0002 3.33329C8.75572 3.33329 6.86127 4.10551 5.31683 5.64996C3.77239 7.1944 3.00016 9.17774 3.00016 11.6C3.00016 13.1777 3.65572 14.9833 4.96683 17.0166C6.27794 19.05 8.28905 21.3111 11.0002 23.8ZM11.0002 27.3333C7.42239 24.2888 4.75016 21.4611 2.9835 18.85C1.21683 16.2388 0.333496 13.8222 0.333496 11.6C0.333496 8.26663 1.40572 5.61107 3.55016 3.63329C5.69461 1.65551 8.17794 0.666626 11.0002 0.666626C13.8224 0.666626 16.3057 1.65551 18.4502 3.63329C20.5946 5.61107 21.6668 8.26663 21.6668 11.6C21.6668 13.8222 20.7835 16.2388 19.0168 18.85C17.2502 21.4611 14.5779 24.2888 11.0002 27.3333Z"
          fill="#555555"
        />
      </svg>
    </SvgIcon>
  );
};

export default LocationPin;
